// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as ContextMaker$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/ContextMaker.res.mjs";

var Api = {
  name: "V3Tutorial"
};

var Context = ContextMaker$LiteracyplanetClientFlags.Make(Api);

function V3TutorialContext$Provider(props) {
  var defaultState = props.defaultState;
  var match = React.useState(function (param) {
        return defaultState;
      });
  var setState = match[1];
  return React.createElement(Context.Provider.make, {
              value: {
                state: match[0],
                onFinishedReading: (function (param) {
                    Curry._1(setState, (function (param) {
                            return "FinishedReadingTutorial";
                          }));
                  }),
                onSetReadingTutorial: (function (param) {
                    Curry._1(setState, (function (param) {
                            return "ReadingTutorial";
                          }));
                  })
              },
              children: props.children
            });
}

var Provider = {
  make: V3TutorialContext$Provider
};

var use = Context.use;

export {
  Api ,
  Context ,
  use ,
  Provider ,
}
/* Context Not a pure module */
